import { render, staticRenderFns } from "./BotaoJuntar.vue?vue&type=template&id=2ec0e170&scoped=true"
import script from "./BotaoJuntar.vue?vue&type=script&lang=js"
export * from "./BotaoJuntar.vue?vue&type=script&lang=js"
import style0 from "./BotaoJuntar.vue?vue&type=style&index=0&id=2ec0e170&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0e170",
  null
  
)

export default component.exports